import React, { useState, useEffect } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import ChildInvestorAcademyCommon from '../../../../../components/common/InvestorAcademyCommon/ChildInvestorAcademyCommon';
import "../../common.css";
import "../../investorAcademy.css";



const EffectiveGearings = (props) => {
    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])
    const location = useLocation();
    const history = useHistory();

    return (
        <div id="investor_academy">
            <div className="imgbg" />
            <div className="mainbg"></div>
            
            <div id="main" className='warrant-sensitivity share_capital Common_warrent'>
                <div id="maintable" style={{display: 'table', width: '100%', tableLayout: 'fixed'}}>
                    <div style={{display: 'table-row'}}>
                    <div id="leftbar" className="hidden-xs" style={{display: 'table-cell', width: '80px'}} />
                    <div id="maincontainer" style={{display: 'table-cell', width: '100%'}}>
                        <div id="mainnav">
                        <table style={{width: '100%', tableLayout: 'fixed', borderBottom: '1px solid #353223'}}>
                            <tbody><tr>
                                <td width="20%" style={{textAlign: 'left', visibility: 'hidden'}}>
                                <table className="hasprev hidden-xs" style={{width: '100%', height: '100%', tableLayout: 'fixed'}}>
                                    <tbody><tr>
                                        <td width="33px"><div className="prev left" /></td>
                                        <td>
                                        <div className="prevlbl left">
                                            <div className="prevtitle " style={{textAlign: 'left'}} />
                                            <div className="prevname " style={{textAlign: 'left'}}>Gearing</div>
                                        </div>
                                        </td>
                                    </tr>
                                    </tbody></table>
                                </td>
                                <td width="60%" style={{textAlign: 'center'}}>
                                <div id="pagetitlediv" style={{width: '365px', height: '100%', borderBottom: '1px solid #FFD843', margin: 'auto'}}>
                                    <div id="ptitle" style={{fontFamily: 'HelveticaNeueThinCond', fontSize: '25px', color: 'white', letterSpacing: '1px'}}>Useful Warrant terms</div>
                                    <div id="pname" style={{fontFamily: 'HelveticaNeueThinCond', fontSize: '30px', color: '#FFD843', letterSpacing: '1px', paddingTop: '5px', paddingBottom: '5px'}}>Effective Gearing</div>
                                </div>
                                </td>
                                <td width="20%" style={{textAlign: 'right', visibility: 'hidden'}}>
                                <table className="hasnext  hidden-xs" style={{width: '100%', height: '100%', tableLayout: 'fixed'}}>
                                    <tbody><tr>
                                        <td>
                                        <div className="nextlbl right">
                                            <div className="nexttitle " style={{textAlign: 'right'}} />
                                            <div className="nextname " style={{textAlign: 'right'}}>Implied Volatility</div>
                                        </div>
                                        </td>
                                        <td width="33px"><div className="next right" /></td>
                                    </tr>
                                    </tbody></table>
                                </td>
                            </tr>
                            </tbody></table>
                        </div>
                        <div id="maincontent" style={{marginLeft: '10px', marginRight: '10px', paddingTop: '40px', marginBottom: '60px'}}>
                        <div id="mainscroll" style={{height: '100%', overflowX: 'hidden', overflowY: 'auto', paddingLeft: '90px', paddingRight: '90px'}}>
                            <div id="mainscrollcontent">
                            <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
                            {/*<link rel="stylesheet" href="css/common.css"/>*/}
                            <title>Effective Gearing</title>
                            <style dangerouslySetInnerHTML={{__html: "\n            .formulaholder{\n            }            \n            .formulaholder p{\n                font-size:1.2em;\n            }\n            .edulist p{\n               text-align: left;\n            }\n            .edulist li {\n                background-image: url('nswCH.png');\n                background-position: -5px;\n                background-repeat: no-repeat;\n                padding-left: 7px;\n            }\n            .edulist .ttl{\n                font-size:16px;\n            }\n            .edulist .formulaholder p{\n                font-size:1em;\n            }\n        " }} />
                            <div className="contentbox">
                                <p>
                                A similar indicator to ‘delta’, it combines gearing and delta to express the warrant price movement as a percentage.  
                                </p>                     
                                <div className="formulaholder" style={{marginLeft: '46px'}}>
                                <div className="formulabox">
                                    <p><span className="hltxt leqt">Effective Gearing</span> = Gearing x Delta</p>
                                </div>
                                </div>
                                <p>There are two main uses for effective gearing:</p>
                                <ol className="edulist">
                                <li>
                                    <p className="ttl"><b>Indicate the % change in the price of a warrant relative to a 1% change in the underlying</b></p>
                                    <p>Take for example a warrant with an effective gearing of 10x. This means, the warrant should move approximately 10% for a 1% movement in the underlying share.</p>
                                    <div className="formulaholder">
                                    <div className="formulabox">
                                        <p><span className="hltxt leqt">Stock 1% x 10</span> = Warrant 10%</p>
                                    </div>
                                    </div>
                                    <p>A higher effective gearing generally translates to a higher profit potential and also a higher level of risk.</p>
                                </li>
                                <li>
                                    <p className="ttl"><b>Helps you decide how much to invest</b></p>
                                    <p>
                                    With effective gearing, you can estimate the effective share exposure in the underlying asset that a warrant holder gains by holding the warrant.<br /><br />
                                    Take for example a warrant with an effective gearing of 10x. This means if an investor buys MYR 10,000 worth of the warrant they will have an effective share exposure of MYR 100,000.
                                    </p>
                                    <div className="formulaholder">
                                    <div className="formulabox">
                                        <p><span className="hltxt leqt">MYR 10,000 Warrant investment x 10</span> = MYR 100,000 effective stock exposure</p>
                                    </div>
                                    </div>
                                    <p>Similarly, if you are currently holding MYR 200,000 worth of shares and wish to release some of these share capital without losing the stock exposure, you can do so by purchasing MYR 20,000 worth of a warrant with an effective gearing of 10x.</p>
                                    <div className="formulaholder">
                                    <div className="formulabox">
                                        <p><span className=" hltxt leqt">MYR 200,000 effective stock exposure / 10</span> = MYR 20,000 Warrant investment</p>
                                    </div>
                                    </div>
                                </li>
                                </ol>
                                <div className="tipholder">
                                <div className="tipbox">
                                    <h2 style={{marginTop:'20px'}}>Helpful Tips on how to use Effective Gearing</h2>
                                    <ul>
                                    <li><p>You can view the effective gearing for all warrants via the <Link target="_blank" to="/tools/warrantsearch">Warrant Search Tool</Link> and the <Link target="_blank" to="/tools/warrantterms">Warrant Terms</Link> page.</p></li>
                                    </ul>
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        <div id="rightbar" className="hidden-xs" style={{display: 'table-cell', width: '80px'}}>
                        </div>
                        </div>
                    </div>
                    <div id="rightbar" className="hidden-xs" style={{display: 'table-cell', width: '80px'}}>
                    </div>
                    </div>
                </div>
            </div>

            <div
                id="bottom"
                style={{
                    position: "fixed",
                    width: "100%",
                    bottom: "0px",
                    height: "40px",
                    backgroundColor: "#101010",
                    zIndex: 10000,
                }}
                >
                <div
                    className="hidden-xs hidden-xxs"
                    style={{
                    display: "table",
                    width: "100%",
                    textAlign: "center",
                    color: "#8F8F8F",
                    fontSize: "11px",
                    lineHeight: "40px",
                    }}
                >
                   <div className='copyright_sec'>
                   Copyright (c) 2016 Macquarie Group Limited ABN 94 122 169 279. All rights
                    reserved.
                   </div>
                </div>
                <div
                    style={{
                    position: "absolute",
                    width: "46%",
                    height: "35px",
                    right: "10px",
                    bottom: "5px",
                    }}
                >
                    <table
                    className="hasnext"
                    style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                    <tbody>
                        <tr>
                        <td>
                            <div className="nextlbl right">
                            <div
                                className="nextname "
                                style={{ textAlign: "right", fontSize: "15px" }}
                            ><Link to="/edu/useful-warrant-terms/implied-volatility">
                               Implied Volatility
                               </Link>
                            </div>
                            </div>
                        </td>
                        <td width="33px">
                        <Link to="/edu/useful-warrant-terms/implied-volatility">
                            <div className="next right" />
                        </Link>
                        </td>
                        </tr>
                    </tbody>
                    </table>
                </div>
                <div
                    style={{
                    position: "absolute",
                    width: "46%",
                    height: "35px",
                    left: "10px",
                    bottom: "5px",
                    }}
                >
                    <table
                    className="hasprev"
                    style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                    <tbody>
                        <tr>
                        <td width="33px">
                        <Link to="/edu/useful-warrant-terms/gearing">
                            <div className="prev left" />
                            </Link>
                        </td>
                        <td>
                            <div className="prevlbl left">
                            <div
                                className="prevname "
                                style={{ textAlign: "left", fontSize: "15px" }}
                            ><Link to="/edu/useful-warrant-terms/gearing">
                                Gearing
                                </Link>
                            </div>
                            </div>
                        </td>
                        </tr>
                    </tbody>
                    </table>
                </div>
            </div>

            <div id="dotbar" className="hidden-sm hidden-xs" style={{}}>
            {/* <div className="dbtn dbtn-seminarbtn">
            <Link
                    className="seminarbtn"
                    to="/education/seminar"
                    >
                    <img src='/img/education/button-static.png' alt="image" />
                    </Link>
                </div> */}
                <ChildInvestorAcademyCommon Location={location} Hist={history} />
            </div>
            </div>

      );
}
export default EffectiveGearings;